import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-navbar',
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive],
    templateUrl: './navbar.component.html',
    styles: []
})
export class NavbarComponent {
    isMenuOpen = signal(false);

    links = [
        { name: 'Home',         path: '/',          icon: 'home',         badge: '' },
        { name: 'Our Services', path: '/services',  icon: 'design_services', badge: '' },
        { name: 'The Ecosystem',path: '/ecosystem', icon: 'hub',          badge: '' },
        { name: 'Gallery',      path: '/gallery',   icon: 'collections',  badge: '' },
        { name: 'Reviews',      path: '/reviews',   icon: 'star',         badge: 'New' },
        { name: 'Contact',      path: '/contact',   icon: 'mail',         badge: '' },
    ];

    toggleMenu() {
        this.isMenuOpen.update(v => !v);
    }

    closeMenu() {
        this.isMenuOpen.set(false);
    }
}
